// src/@shared/utils/Seasons.js

export const SEASONS = [
  // -------- Season 1 (Extended Alpha) --------
  {
    name: "Alpha",
    startDate: "6-4-2025",
    endDate: "1-3-2026",
    season: 1,
    img: "",
  },

  // -------- 2026 --------
  {
    name: "Genesis",
    startDate: "1-4-2026",
    endDate: "7-3-2026",
    season: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/marketing%2FChatGPT%20Image%20Jan%205%2C%202026%2C%2004_25_25%20AM.png?alt=media&token=37e9e142-2443-486f-a23f-1a87caf03371",
  },
  {
    name: "Ascension",
    startDate: "7-4-2026",
    endDate: "10-3-2026",
    season: 3,
    img: "",
  },
  {
    name: "Eclipse War",
    startDate: "10-4-2026",
    endDate: "2-3-2027",
    season: 4,
    img: "",
  },

  // -------- 2027 --------
  {
    name: "Shattered Realms",
    startDate: "2-4-2027",
    endDate: "5-3-2027",
    season: 5,
    img: "",
  },
  {
    name: "Infinity Uprising",
    startDate: "6-4-2027",
    endDate: "10-3-2027",
    season: 6,
    img: "",
  },
  {
    name: "Voidfall Dominion",
    startDate: "10-4-2027",
    endDate: "2-3-2028",
    season: 7,
    img: "",
  },
];

const parseSeasonBoundary = (value, boundary = "start") => {
  if (!value) return null;
  const [month, day, year] = String(value)
    .split("-")
    .map((part) => Number(part));

  if (![month, day, year].every((n) => Number.isFinite(n))) return null;

  const date = new Date(year, month - 1, day);
  if (Number.isNaN(date.getTime())) return null;

  if (boundary === "end") {
    date.setHours(23, 59, 59, 999);
  } else {
    date.setHours(0, 0, 0, 0);
  }

  return date;
};

const normalizedSeasons = () =>
  [...SEASONS]
    .map((season) => ({
      ...season,
      _start: parseSeasonBoundary(season.startDate, "start"),
      _end: parseSeasonBoundary(season.endDate, "end"),
    }))
    .filter((season) => season._start && season._end)
    .sort((a, b) => a._start - b._start);

export const getSeasonForDate = (dateInput = new Date()) => {
  const targetDate = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (Number.isNaN(targetDate.getTime())) return null;

  const seasons = normalizedSeasons();
  if (!seasons.length) return null;

  const inRange = seasons.find(
    (season) => targetDate >= season._start && targetDate <= season._end,
  );
  if (inRange) return inRange;

  if (targetDate < seasons[0]._start) return seasons[0];
  return seasons[seasons.length - 1];
};

export const getCurrentSeason = () => getSeasonForDate(new Date());

export const getSeasonNumberForDate = (dateInput = new Date()) =>
  getSeasonForDate(dateInput)?.season ?? null;
